module.exports = __webpack_public_path__ + "static/media/wine-stroll-flyer-2019.70ae2ca7.pdf";